import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './App.css';
import LandingPage from './pages/LandingPage';
import Dashboard from './pages/Dashboard';
import WeekPage from './pages/WeekPage';
import CompletionPage from './pages/CompletionPage';
import WelcomePage from './pages/WelcomePage';
import AboutPage from './pages/AboutPage';
import TermsPage from './pages/TermsPage';
import UnsubscribePage from './pages/UnsubscribePage';
import CookieConsent from './components/CookieConsent';
import { Toaster } from './components/ui/sonner';
import { initGA, setUserCohort } from './utils/analytics';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance
export const api = axios.create({
  baseURL: API,
});

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Initialize Google Analytics
    initGA();
    
    // Check for existing user in localStorage
    const storedUser = localStorage.getItem('careerlaunch_user');
    if (storedUser) {
      const userData = JSON.parse(storedUser);
      setUser(userData);
      // Set user cohort for GA filtering
      setUserCohort(userData.user_cohort);
    }
  }, []);

  const handleSignup = (userData) => {
    setUser(userData);
    localStorage.setItem('careerlaunch_user', JSON.stringify(userData));
    // Set user cohort for GA filtering
    setUserCohort(userData.user_cohort);
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage onSignup={handleSignup} user={user} />} />
          <Route path="/welcome" element={<WelcomePage user={user} />} />
          <Route path="/dashboard" element={<Dashboard user={user} />} />
          <Route path="/week/:weekNumber" element={<WeekPage user={user} />} />
          <Route path="/completion" element={<CompletionPage user={user} />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/unsubscribe" element={<UnsubscribePage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
      <CookieConsent />
    </div>
  );
}

export default App;